<template>

    <div>
        <div
            class="fb-share-button icon-social-link"
            :data-href="
                'https://inis.qc.ca/' +
                content.jsonUrl"
            data-layout="button"
            data-size="small"
        >
            <a
                target="_blank"
                :href="
                    'https://www.facebook.com/sharer/sharer.php?u=' +
                    'https://inis.qc.ca/' +
                    content.jsonUrl +
                    '&amp;src=sdkpreparse'
                "
                class="fb-xfbml-parse-ignore icon-social-link"
            >
                <span class="fa-stack">
                    <i class="fa-solid fa-circle fa-stack-2x"></i>
                    <i class="fa-brands fa-facebook-f fa-stack-1x fa-inverse"></i>
                </span>
            </a>
        </div>

        <a
            class="icon-social-link"
            :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + content.url"
            target="_blank"
        >
            <span class="fa-stack">
                <i class="fa-solid fa-circle fa-stack-2x"></i>
                <i class="fa-brands fa-linkedin-in fa-stack-1x fa-inverse"></i>
            </span>
        </a>

        <a
            class="icon-social-link"
            :href="
                'mailto:?subject=Ceci pourrait vous intéresser &body=Bonjour, Ceci pourrait vous intéresser : ' +
                content.url
            "
            alt="email share"
            target="_blank"
        >
            <span class="fa-stack">
                <i class="fa-solid fa-circle fa-stack-2x"></i>
                <i class="fa-regular fa-envelope fa-stack-1x fa-inverse"></i>
            </span>
        </a>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'ShareLinks',

    // On loaded...
    mounted() {},

    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['content', 'globals']),
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
